<ng-container *transloco="let t">
  @if (tutorialService.showTutorial()) {
    <div appearance="outline" class="max-w-72 shadow-xl! animate-in fade-in slide-in-from-left-8" tuiCardLarge>
      <div class="flex items-center gap-2 text-sm text-text-tertiary">
        <tui-icon class="text-base" icon="@tui.circle-help" />
        {{ t('Tutoriel') }}
        <button class="ml-auto" data-testid="close-btn" tuiButtonX type="button" (click)="tutorialService.dismiss()">
          {{ t('Fermer') }}
        </button>
      </div>
      <div tuiTitle>
        {{ t("Placez des points sur l'image pour détourer la lésion") }}
        <div tuiSubtitle>
          {{ t('Pour terminer, fermez la forme en rejoignant le premier point.') }}
        </div>
      </div>
      <video
        autoplay
        class="aspect-video rounded-sm bg-background-secondary"
        loop
        muted
        src="assets/videos/woundtrack-tutorial.mp4"></video>
      <div>
        <tui-icon icon="mouse_left" />
        <span class="ml-2">{{ t('Placer un point') }}</span>
      </div>
    </div>
  }
</ng-container>
